module.exports = __webpack_public_path__ + "static/media/PxGroteskRegularItalic.26f659b7.ttf";